import Konva from 'konva';
import InverterString from "../lib/InverterString";

export default class InverterStringLine {
    panelCount: number;
    used: number;
    panels: number[];
    points: number[];
    paints: Konva.Group[];
    panelPaints: Konva.Node[];
    stringLine: Konva.Line;
    string: InverterString;

    constructor(string: InverterString, panelCount: number, color: string, layer: any) {
        this.string = string;
        this.panelCount = panelCount;
        this.used = 0;
        this.panels = [];
        this.points = [];
        this.paints = [];
        this.panelPaints = [];
        const name = string.name.toLowerCase();
        this.stringLine = new Konva.Line({
            points: [],
            stroke: color,
            strokeWidth: 1,
            lineJoin: 'round',
            /*
             * line segments with a length of 20px
             * with a gap of 5px
             */
            dash: [20, 0],
            name: name.replace(" ", "_")
        });
        layer.add(this.stringLine);
        this.stringLine.on("click", () => {
            console.log(this.stringLine, this.string);
        });
    }

}
